// agents are flagged after 9 months (270 days) without members
export const NO_MEMBERS_FLAG_DAYS = 270;
export const NO_MEMBERS_FLAG_LABEL = '9+ Months without policy sold';

/**
 * builds the list of warning flags to show for an agent row
 * @param agent - agent record returned by the agency dashboard agents endpoint
 */
export function getAgentFlags(agent) {
  const flags = [];
  const daysSinceNoMembers = Number(agent?.Days_Since_No_Members);

  if (
    Number.isFinite(daysSinceNoMembers) &&
    daysSinceNoMembers >= NO_MEMBERS_FLAG_DAYS
  ) {
    flags.push(NO_MEMBERS_FLAG_LABEL);
  }
  return flags;
}
